(function ($) {
    if ($('.single-project-map #map').length) {
        let projectsMap;
        let overviewMap;
        let directionsRenderer;
        let directionsService;
        let geocoder;
        let routeStartMarker;
        let routeDrawn = false;
        const infoWindows = [];
        const poiMarkers = [];
        let polylineOptions;
        let walkingPolylineOptions;
        const transitInfoWindows = [];
        const polylines = [];
        const OVERVIEW_DIFFERENCE = 5;
        const OVERVIEW_MIN_ZOOM = 3;
        const OVERVIEW_MAX_ZOOM = 10;


        const poiMarkerIconClosed = {url: liven.template_directory + "/assets/images/map-marker-round.svg"};
        const poiMarkerIconOpen = {url: liven.template_directory + "/assets/images/map-marker-round-red.svg"};
        const projectAreaCoords = projectArea.features;
        var map;

        function ZoomControl(controlDiv, map) {
            controlDiv.setAttribute('class', 'zoom-controls');

            const zoomInButton = document.createElement('div');
            zoomInButton.setAttribute('class', 'zoom-button zoom-in');
            controlDiv.appendChild(zoomInButton);

            const zoomOutButton = document.createElement('div');
            zoomOutButton.setAttribute('class', 'zoom-button zoom-out');
            controlDiv.appendChild(zoomOutButton);

            zoomInButton.addEventListener('click', function () {
                projectsMap.setZoom(projectsMap.getZoom() + 1);
                if(projectsMap.getZoom() <= 14) {
                    $('.popup.single-popup-project').css('display','none');
                }else {
                    $('.popup.single-popup-project').css('display','block');
                }
            });

            zoomOutButton.addEventListener('click', function () {
                projectsMap.setZoom(projectsMap.getZoom() - 1);
                if(projectsMap.getZoom() <= 14) {
                    $('.popup.single-popup-project').css('display','none');
                }else {
                    $('.popup.single-popup-project').css('display','block');
                }
            });
        }


        function closeAllInfoWindows() {
            for (let infoWindow of infoWindows) {
                infoWindow.close();
            }
        }

        function closeTransitInfoWindows() {
            for (let infoWindow of transitInfoWindows) {
                infoWindow.close();
            }
        }

        function resetPoiMarkerIcons() {
            for (let marker of poiMarkers) {
                marker.setIcon(poiMarkerIconClosed);
            }
        }

        function attachPolygonInfoWindow(polygon, coors, html,z) {

            polygon.infoWindow = new google.maps.InfoWindow({
                content: html,
                zIndex: 1
            });

            polygon.infoWindow.setPosition(getHighestWindowPosition(coors));
            polygon.infoWindow.open(map, polygon);
            polygon.infoWindow.setZIndex(z);
        }

        function getHighestWindowPosition(coors) {

            var lat = -5000, lng = 0, i = 0, n = coors.length;

            for (; i !== n; ++i) {
                if (coors[i].lat > lat) {
                    lat = coors[i].lat;
                    lng = coors[i].lng;
                }
            }
            return {lat: lat, lng: lng};

        }

        function displayDirectionsInstructions(directions) {
            const startAddress = directions.start_address.split(",")[0];
            const departureTime = directions.departure_time.value.toLocaleTimeString([], { timeStyle: 'short' })
            const arrivalTime = directions.arrival_time.value.toLocaleTimeString([], { timeStyle: 'short' })
            const steps = directions.steps;

            $('.direction-details-wrapper').empty();

            for (let i = 0; i < steps.length; i++) {
                const travelMode = steps[i].travel_mode;
                const duration = steps[i].duration.text;
                const distance = steps[i].distance.text;

                const transitInfoWindow = new google.maps.InfoWindow({
                    content:
                        `<div class="popup popup-transit">
                            <img src="${liven.template_directory + `/assets/images/${travelMode.toLowerCase()}-icon-white.svg`}" alt="">
                            <div>
                                <p>${duration}</p>
                                <span>${distance}</span>
                            </div>
                        </div>`,
                    position: steps[i].start_point
                });

                transitInfoWindows.push(transitInfoWindow);
                transitInfoWindow.open(projectsMap);
            }

            for (let i = 0; i < steps.length; i++) {
                const duration = steps[i].duration.text;
                const distance = steps[i].distance.text;
                const travelMode = steps[i].travel_mode;

                // First step
                if (i === 0) {
                    $('.direction-details-wrapper').append(`
                        <div class="route-leg ${travelMode === "WALKING" ? "walking" : ""}">
                            <p class="time">${departureTime}</p>
                            <div class="line"></div>
                            <div class="leg-info">
                                <h6>${startAddress}</h6>
                                <div class="info">
                                    <img src="${liven.template_directory + `/assets/images/${travelMode.toLowerCase()}-icon.svg`}" alt="">
                                    <p>(${duration} - ${distance})</p>
                                </div>
                            </div>
                        </div>
                    `);
                }

                // Last step
                else if (i === steps.length - 1) {
                    $('.direction-details-wrapper').append(`
                        <div class="route-leg ${travelMode === "WALKING" ? "walking" : ""}">
                            <p class="time">${arrivalTime}</p>
                            <div class="line"></div>
                            <div class="leg-info">
                                <h6>${projectName}</h6>
                            </div>
                        </div>
                    `);
                }

                // Middle steps
                else {
                    if (travelMode === "TRANSIT") {
                        $('.direction-details-wrapper').append(`
                            <div class="route-leg ${travelMode === "WALKING" ? "walking" : ""}">
                                <p class="time">${steps[i].transit.departure_time.value.toLocaleTimeString([], { timeStyle: 'short' })}</p>
                                <div class="line"></div>
                                <div class="leg-info">
                                    <h6>${steps[i].transit.departure_stop.name}</h6>
                                    <div class="info">
                                        <img src="${liven.template_directory + `/assets/images/${travelMode.toLowerCase()}-icon.svg`}" alt="">
                                        <p><span class="bus-number">${steps[i].transit.line.short_name ? steps[i].transit.line.short_name : steps[i].transit.line.name}</span><span>(${duration} - ${distance})</span></p>
                                    </div>
                                </div>
                            </div>
                        `);

                        if (steps[i+1].travel_mode === "WALKING") {
                            $('.direction-details-wrapper').append(`
                                <div class="route-leg walking">
                                    <p class="time">${steps[i].transit.arrival_time.value.toLocaleTimeString([], { timeStyle: 'short' })}</p>
                                    <div class="line"></div>
                                    <div class="leg-info">
                                        <h6>${steps[i].transit.arrival_stop.name}</h6>
                                        <div class="info">
                                            <img src="${liven.template_directory + '/assets/images/walking-icon.svg'}" alt="">
                                            <p>(${steps[i+1].duration.text} - ${steps[i+1].distance.text})</p>
                                        </div>
                                    </div>
                                </div>
                            `);
                        }
                    }
                }
            }
        }

        function renderDirectionsPolylines(response, index) {
            if (!index) index = 0;
            for (var i = 0; i < polylines.length; i++) {
                polylines[i].setMap(null);
            }
            var bounds = new google.maps.LatLngBounds();
            var legs = response.routes[index].legs;
            for (i = 0; i < legs.length; i++) {
                var steps = legs[i].steps;
                for (let j = 0; j < steps.length; j++) {
                    var nextSegment = steps[j].path;
                    var stepPolyline = new google.maps.Polyline(polylineOptions);
                    if (steps[j].travel_mode == google.maps.TravelMode.WALKING) {
                        stepPolyline.setOptions(walkingPolylineOptions)
                    }
                    for (let k = 0; k < nextSegment.length; k++) {
                        stepPolyline.getPath().push(nextSegment[k]);
                        bounds.extend(nextSegment[k]);
                    }
                    stepPolyline.setMap(projectsMap);
                    polylines.push(stepPolyline);
                    projectsMap.fitBounds(bounds);
                    if(projectsMap.getZoom() <= 14) {
                        $('.popup.single-popup-project').css('display','none');
                    }else {
                        $('.popup.single-popup-project').css('display','block');
                    }
                }
            }
        }

        function drawRouteDirections(userLocation, travelMode) {

            directionsRenderer.setMap(null);

            closeTransitInfoWindows();

            geocoder.geocode( { 'address': userLocation}, function(results, status) {

                if (status == 'OK') {
                    const originLocation = results[0].geometry.location;

                    // Changing walking directions color
                    google.maps.Polyline.prototype.setMap = (function (f, r) {
                        return function (map) {
                            if (this.get('icons') && this.get('icons').length === 1 && this.get('strokeOpacity') === 0 && !this.get('noRoute')) {
                                if (r.get('polylineOptions') && r.get('polylineOptions').strokeColor) {
                                    var icons = this.get('icons'),
                                    color = r.get('polylineOptions').strokeColor;
                                    icons[0].icon.fillOpacity = 1;
                                    icons[0].icon.fillColor = color;
                                    icons[0].icon.strokeColor = color;
                                    this.set('icons', icons);
                                }
                            }
                            f.apply(this, arguments);
                        }
                    })(google.maps.Polyline.prototype.setMap, directionsRenderer);

                    directionsService.route({
                        origin: originLocation,
                        destination: {lat: projectLocation.lat, lng: projectLocation.lng},
                        travelMode: google.maps.TravelMode[travelMode]
                    }, function(response, status) {
                        if (status == google.maps.DirectionsStatus.OK) {

                            directionsRenderer.setDirections(response);
                            directionsRenderer.setMap(null);
                            renderDirectionsPolylines(response);

                            if (travelMode === "TRANSIT" && response.routes[0].legs[0].steps.length > 1) {
                                const departureTime = response.routes[0].legs[0].departure_time.value.toLocaleTimeString([], { timeStyle: 'short' });
                                const arrivalTime = response.routes[0].legs[0].arrival_time.value.toLocaleTimeString([], { timeStyle: 'short' });
                                const travelDuration = response.routes[0].legs[0].duration.text
                                $('.route-finder .directions-info').addClass('active');
                                $('.route-finder .departure-time').text(departureTime)
                                $('.route-finder .arrival-time').text(arrivalTime)
                                $('.route-finder .time-duration').text(travelDuration)

                                displayDirectionsInstructions(response.routes[0].legs[0]);
                            } else {
                                const duration = response.routes[0].legs[0].duration.text;
                                const distance = response.routes[0].legs[0].distance.text;

                                $('.route-finder .directions-info').removeClass('active');

                                const transitInfoWindow = new google.maps.InfoWindow({
                                    content:
                                        `<div class="popup popup-transit">
                                            <img src="${liven.template_directory + `/assets/images/${travelMode.toLowerCase()}-icon-white.svg`}" alt="">
                                            <div>
                                                <p>${duration}</p>
                                                <span>${distance}</span>
                                            </div>
                                        </div>`,
                                    position: response.routes[0].legs[0].start_location
                                });

                                transitInfoWindows.push(transitInfoWindow);
                                transitInfoWindow.open(projectsMap);
                            }

                            if (routeStartMarker) {
                                routeStartMarker.setPosition(originLocation);
                                routeStartMarker.setVisible(true);
                            } else {
                                routeStartMarker = new google.maps.Marker({
                                    position: response.routes[0].legs[0].start_location,
                                    map: projectsMap,
                                    icon: poiMarkerIconOpen,
                                });
                            }

                            routeDrawn = true;
                        } else {
                            directionsRenderer.setMap(null);
                        }
                    });
                } else {
                    // routeStartMarker.setVisible(false);
                    routeDrawn = false;
                }
            });
        }


        function initProjectMap() {
            const styledMapType = new google.maps.StyledMapType(
                [
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#545B5C"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#F2F2F2"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#FFFFFF"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#E6F3D6"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 45
                            },
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#E6E8EC"
                            },
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "color": "#4E4E4E"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#E6E8EC"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#787878"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#E6E8EC"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#6C6C6C"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#EAF6F8"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#2389da"
                            }
                        ]
                    }
                ],
                {name: "Styled Map"}
            );

            projectsMap = new google.maps.Map(document.getElementById("map"), {
                center: {
                    lat: parseFloat(mapCenter.latitude) ? parseFloat(mapCenter.latitude) : 59.44,
                    lng: parseFloat(mapCenter.longitude) ? parseFloat(mapCenter.longitude) : 24.73
                },
                zoom: zoomLevel ? parseInt(zoomLevel) : 13,
                disableDefaultUI: true,
            });
            overviewMap = new google.maps.Map(document.getElementById("overview"), {
                center: {
                    lat: parseFloat(mapCenter.latitude) ? parseFloat(mapCenter.latitude) : 59.44,
                    lng: parseFloat(mapCenter.longitude) ? parseFloat(mapCenter.longitude) : 24.73
                },
                zoom: zoomLevel ? parseInt(zoomLevel) : 13,
                disableDefaultUI: true,
            });
            if (window.matchMedia('(max-width: 450px)').matches) {
                projectsMap.setZoom(15.4)
            }

            directionsRenderer = new google.maps.DirectionsRenderer;
            directionsService = new google.maps.DirectionsService;
            // Markers and infoWindow
            geocoder = new google.maps.Geocoder();
            polylineOptions = {
                strokeColor: '#FF3D60',
                strokeOpacity: 1,
                strokeWeight: 4
            };
            walkingPolylineOptions = {
                strokeColor: '#FF3D60',
                strokeOpacity: 0,
                strokeWeight: 4,
                icons: [{
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        fillColor: '#FF3D60',
                        fillOpacity: 1,
                        scale: 2,
                        strokeColor: '#FF3D60',
                        strokeOpacity: 1,
                    },
                    offset: '0',
                    repeat: '10px'
                }]
            };
            if(defaultMapView === 'styled_map') {
                projectsMap.mapTypes.set("styled_map", styledMapType);
                projectsMap.setMapTypeId("styled_map");
                overviewMap.setMapTypeId("satellite");
            }else {
                projectsMap.setMapTypeId("satellite");
                overviewMap.mapTypes.set("styled_map", styledMapType);
                overviewMap.setMapTypeId("styled_map");
            }

            // Custom zoom controls
            const zoomControlDiv = document.createElement('div');
            const zoomControl = new ZoomControl(zoomControlDiv, map);

            zoomControlDiv.index = 1;
            projectsMap.controls[google.maps.ControlPosition.BOTTOM_RIGHT].push(zoomControlDiv);


            for (let poi of mapPois) {
                const infoWindow = new google.maps.InfoWindow({
                    content:
                        `<div class="popup">
                            <p>${poi.popup_text}</p>
                        </div>`,
                });

                infoWindow.setZIndex(50); //test tootab
                infoWindows.push(infoWindow);
                let projectCoordinatesArr = [];
                let pointsOfInterestCoordinates = [];
                if(projectAreaCoords[0].geometry.coordinates.length === 1){
                    projectCoordinatesArr.push({
                        lat: projectAreaCoords[0].geometry.coordinates[0][0][1],
                        lng: projectAreaCoords[0].geometry.coordinates[0][0][0]
                    })
                }else if(projectAreaCoords[0].geometry.coordinates.length === 2){
                    projectCoordinatesArr.push({
                        lat: projectAreaCoords[0].geometry.coordinates[1],
                        lng: projectAreaCoords[0].geometry.coordinates[0]
                    })
                }
                pointsOfInterestCoordinates.push({
                    lat: poi.location.lat,
                    lng: poi.location.lng
                })
                var projectCoordinatesMarker = new google.maps.Marker({position: projectCoordinatesArr[0], map: map})
                var pointsOfInterestMarker = new google.maps.Marker({position: pointsOfInterestCoordinates[0], map: map})
                var distance = haversine_distance(pointsOfInterestMarker, projectCoordinatesMarker);
                if(poiKmRange !== null && poiKmRange !== '') {
                    if(distance <= poiKmRange  ) {
                        const marker = new google.maps.Marker({
                            position: {lat: poi.location.lat, lng: poi.location.lng},
                            icon: poiMarkerIconClosed,
                            map: projectsMap,
                            category: poi.category.value
                        });

                        poiMarkers.push(marker);
                        marker.addListener("click", () => {
                            closeAllInfoWindows();
                            resetPoiMarkerIcons();

                            infoWindow.open({
                                anchor: marker,
                                projectsMap,
                                shouldFocus: false,
                            });

                            marker.setIcon(poiMarkerIconOpen);
                        });

                        marker.addListener("mouseover", () => {
                            closeAllInfoWindows();
                            resetPoiMarkerIcons();

                            infoWindow.open({
                                anchor: marker,
                                projectsMap,
                                shouldFocus: false
                            });

                            marker.setIcon(poiMarkerIconOpen);

                        });

                        marker.addListener("mouseout", () => {
                            closeAllInfoWindows();
                            resetPoiMarkerIcons();
                        });
                    }
                }else{
                    const marker = new google.maps.Marker({
                        position: {lat: poi.location.lat, lng: poi.location.lng},
                        icon: poiMarkerIconClosed,
                        map: projectsMap,
                        category: poi.category.value
                    });
                    poiMarkers.push(marker);
                    marker.addListener("click", () => {
                        closeAllInfoWindows();
                        resetPoiMarkerIcons();

                        infoWindow.open({
                            anchor: marker,
                            projectsMap,
                            shouldFocus: false,
                        });

                        marker.setIcon(poiMarkerIconOpen);
                    });

                    marker.addListener("mouseover", () => {
                        closeAllInfoWindows();
                        resetPoiMarkerIcons();

                        infoWindow.open({
                            anchor: marker,
                            projectsMap,
                            shouldFocus: false,
                        });

                        marker.setIcon(poiMarkerIconOpen);
                    });

                    marker.addListener("mouseout", () => {
                        closeAllInfoWindows();
                        resetPoiMarkerIcons();
                    });
                }
            }

            if(projectTitle['latitude'] !== '' && projectTitle['longitude'] !== '') {
            const projectPath = [];
                projectPath.push({
                    lat: parseFloat(projectTitle['latitude']),
                    lng: parseFloat(projectTitle['longitude'])
                })

                const projectTitlePosition = new google.maps.Polygon({
                    paths: projectPath,
                    content: projectName,
                });
                projectTitlePosition.setMap(projectsMap);
                attachPolygonInfoWindow(projectTitlePosition, projectPath, `
                    <div class="popup popup-project">
                        <p>${projectName}</p>
                    </div>
                `, 9);
                //projectTitlePosition.setOptions({ zIndex: 1 });
            }
            projectAreaCoords.forEach(function (coordinate, index) {


                const polygonPath = [];
                const projectPath2 = [];
                coordinate.geometry.coordinates[0].forEach(function (coordinate, index) {
                    polygonPath.push({
                        lat: coordinate[1],
                        lng: coordinate[0]
                    })
                    if(projectTitle['latitude'] === '' && projectTitle['longitude'] === '') {
                        if(index === 0) {
                            if (window.matchMedia('(max-width: 450px)').matches) {
                                projectPath2.push({
                                    lat: coordinate[1] + 0.0004,
                                    lng: coordinate[0] + 0.0025
                                })
                            }else {
                                projectPath2.push({
                                    lat: coordinate[1],
                                    lng: coordinate[0] + 0.0032
                                })
                            }
                        }
                    }
                })
                const polygon = new google.maps.Polygon({
                    paths: polygonPath,
                    fillColor: '#FF3D60',
                    fillOpacity: '0.4',
                    strokeColor: '#FF3D60',
                    strokeOpacity: coordinate.properties['stroke-opacity'],
                    strokeWeight: coordinate.properties['stroke-width'],
                    content: coordinate.properties.text,
                });

                polygon.setMap(projectsMap);

                if(polygon.content) {
                    attachPolygonInfoWindow(polygon, polygonPath, `
                        <div class="popup single-popup-project">
                            <p>${polygon.content}</p>
                        </div>
                    `, 1);
                }

                if(projectTitle['latitude'] === '' && projectTitle['longitude'] === '') {
                    const projectTitlePosition2 = new google.maps.Polygon({
                        paths: projectPath2,
                    });
                    projectTitlePosition2.setMap(projectsMap);

                    if (index === 0) {
                        attachPolygonInfoWindow(projectTitlePosition2, projectPath2, `
                            <div class="popup popup-project">
                                <p>${projectName}</p>
                            </div>
                        `, 9);
                    }
                }
            });
            projectsMap.addListener('click', () => {
                if (event.placeId) {
                    event.stop();
                } else {
                    closeAllInfoWindows();
                    resetPoiMarkerIcons();
                }
            });
            projectsMap.addListener("bounds_changed", () => {
                overviewMap.setCenter(projectsMap.getCenter());
                overviewMap.setZoom(
                    clamp(
                        projectsMap.getZoom() - OVERVIEW_DIFFERENCE,
                        OVERVIEW_MIN_ZOOM,
                        OVERVIEW_MAX_ZOOM
                    )
                );

            });
            $('#overview').click(function(){
                if (projectsMap.getMapTypeId() == 'styled_map') {
                    projectsMap.setMapTypeId(google.maps.MapTypeId.SATELLITE);
                    overviewMap.mapTypes.set("styled_map", styledMapType);
                    overviewMap.setMapTypeId("styled_map");
                }else {
                    projectsMap.mapTypes.set("styled_map", styledMapType);
                    projectsMap.setMapTypeId("styled_map");
                    overviewMap.setMapTypeId(google.maps.MapTypeId.SATELLITE);
                }
            })
        }
        function clamp(num, min, max) {
            return Math.min(Math.max(num, min), max);
        }

        window.initProjectMap = initProjectMap;

        $('.map-categories li').on('click', function () {
            if ($(this).hasClass('active')) return;

            const category = $(this).data('category');
            $(this).addClass('active').siblings().removeClass('active');

            closeAllInfoWindows();
            resetPoiMarkerIcons();
            var bounds = new google.maps.LatLngBounds();



            if (category === "all") {

                poiMarkers.forEach((marker, index) => {
                    marker.setVisible(true)
                    bounds.extend( marker.getPosition() );
                    projectsMap.fitBounds(bounds);
                    if(projectsMap.getZoom() <= 14) {
                        $('.popup.single-popup-project').css('display','none');
                    }else {
                        $('.popup.single-popup-project').css('display','block');
                    }
                    for (var i = 0; i < polylines.length; i++) {
                        polylines[i].setMap(null);
                    }
                    drawRouteDirections('','');
                })
            } else {
                poiMarkers.forEach((marker, index) => {
                    if (marker.category === category) {
                        marker.setVisible(true)
                        bounds.extend( marker.getPosition() );
                        projectsMap.fitBounds(bounds);
                        if(projectsMap.getZoom() <= 14) {
                            $('.popup.single-popup-project').css('display','none');
                        }else {
                            $('.popup.single-popup-project').css('display','block');
                        }
                        for (var i = 0; i < polylines.length; i++) {
                            polylines[i].setMap(null);
                        }
                        drawRouteDirections('','');

                    } else {
                        marker.setVisible(false)
                    }
                })
            }
        })

        $('.map-categories-mobile .header').on('click', function () {
            const parent = $(this).closest('.map-categories-mobile');
            const nav = parent.find('ul');

            parent.toggleClass('active');
            nav.slideToggle();
        })

        $('.map-categories-mobile li').on('click', function () {
            if ($(this).hasClass('active')) return;

            const category = $(this).data('category');
            const parent = $(this).closest('.map-categories-mobile');
            const tabName = $(this).text();
            const nav = $(parent).find('ul');
            const status = $(this).data('status');

            $(this).addClass('active').siblings().removeClass('active');
            parent.toggleClass('active');
            nav.slideToggle();
            parent.find('.header p').text(tabName);


            closeAllInfoWindows();
            resetPoiMarkerIcons();

            var bounds = new google.maps.LatLngBounds();
            if (category === "all") {
                poiMarkers.forEach((marker, index) => {
                    marker.setVisible(true)
                    bounds.extend( marker.getPosition() );
                    projectsMap.fitBounds(bounds);
                    if(projectsMap.getZoom() <= 14) {
                        $('.popup.single-popup-project').css('display','none');
                    }else {
                        $('.popup.single-popup-project').css('display','block');
                    }
                    for (var i = 0; i < polylines.length; i++) {
                        polylines[i].setMap(null);
                    }
                    drawRouteDirections('','');

                })
            } else {
                poiMarkers.forEach((marker, index) => {
                    if (marker.category === category) {
                        marker.setVisible(true)
                        for (var i = 0; i < polylines.length; i++) {
                            polylines[i].setMap(null);
                        }
                        drawRouteDirections('','');
                        // extending bounds to contain this visible marker position
                        bounds.extend( marker.getPosition() );
                        projectsMap.fitBounds(bounds);
                        if(projectsMap.getZoom() <= 14) {
                            $('.popup.single-popup-project').css('display','none');
                        }else {
                            $('.popup.single-popup-project').css('display','block');
                        }

                    } else {
                        marker.setVisible(false)
                    }
                })
            }
        })

        $('.directions-type-selection li').on('click', function() {
            if ($(this).hasClass('active')) return;

            const travelMode = $(this).data('travel-mode');
            $(this).addClass('active').siblings().removeClass('active');

            if (routeDrawn) {
                drawRouteDirections($('.route-finder #location-input').val(), travelMode);
            }
        })

        $('.route-finder form').on('submit', function() {
            $('.route-finder #location-input').blur()
        });

        $('.route-finder form .button').on('click', function(e) {
            e.preventDefault();
            const searchQuery = $('.route-finder #location-input').val();
            $('.route-finder #location-input').blur()

            if (!searchQuery.trim().length) {
                $('.directions-type-selection').removeClass('active');
            }

            drawRouteDirections(searchQuery, $('.directions-type-selection li.active').data('travel-mode'));
        });

        $('.route-finder .toggle-details').on('click', function() {
            const $this = $(this);
            $('.route-finder .directions-details').toggleClass('opened');
            $('.route-finder .directions-details').slideToggle();

            if ($('.route-finder .directions-details').hasClass('opened')) {
                $this.find('span').text($this.data('close-text'))
            } else {
                $this.find('span').text($this.data('open-text'))
            }
        })
        function haversine_distance(mk1, mk2) {
            var R = 6371.0710;//km
            var rlat1 = mk1.position.lat() * (Math.PI/180); // Convert degrees to radians
            var rlat2 = mk2.position.lat() * (Math.PI/180); // Convert degrees to radians
            var difflat = rlat2-rlat1; // Radian difference (latitudes)
            var difflon = (mk2.position.lng()-mk1.position.lng()) * (Math.PI/180); // Radian difference (longitudes)
            var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
            return d;
        }

    }
})(jQuery);
